unit StatusType;
{

/* Initail. */

}
interface

uses
  JS;

type
  TStatusType = class
  private
    fStatusKey: String;
    fName: String;
    fActive: Boolean;
  public
    property StatusKey: String read fStatusKey;
    property Name: String read fName;
    property Active: Boolean read fActive;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TStatusType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fStatusKey := String(JSObject_Type['statusKey']);
    fName := String(JSObject_Type['name']);
    fActive := (String(JSObject_Type['active']) = 'true');
  end;
end;

end.
